<core-header></core-header>
<main>
    <router-outlet></router-outlet>
</main>
<core-footer></core-footer>
